<div class="errorpage-content col-lg-6 offset-lg-3">
  <h1>{{ 'servererror.page.title' | translate }}</h1>
  <div class="error-text">
    <div [ishServerHtml]="'servererror.page.text' | translate"></div>
    <p class="text-muted" (click)="expand()" (keydown.enter)="expand()" tabindex="0">
      @switch (httpError?.status) { @case (undefined) {
      {{ stringError | translate }}
      } @case (0) { Server timeout } @default { Error code {{ httpError.status }}<br />
      {{ type() }}
      } }
    </p>
    @if (expanded) {
    <pre>{{ error() | json }}</pre>
    }
  </div>
</div>
